import { Component, Mixins } from "vue-property-decorator";

import RoutingMixin from "mixins/Routing";
import RequestsMixin from "mixins/http/RequestsMixin";
import { SurveysMixin } from "mixins/http";

@Component({})
class UserSurveyService extends Mixins(
  RoutingMixin,
  RequestsMixin,
  SurveysMixin
) {}

export default new UserSurveyService();
